export default __webpack_public_path__ + "static/media/infinite.aafb6f77.jpg";